import { render, staticRenderFns } from "./msgBox.vue?vue&type=template&id=4651179a"
import script from "./msgBox.vue?vue&type=script&lang=js"
export * from "./msgBox.vue?vue&type=script&lang=js"
import style0 from "./msgBox.vue?vue&type=style&index=0&id=4651179a&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/source/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4651179a')) {
      api.createRecord('4651179a', component.options)
    } else {
      api.reload('4651179a', component.options)
    }
    module.hot.accept("./msgBox.vue?vue&type=template&id=4651179a", function () {
      api.rerender('4651179a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/msgBox.vue"
export default component.exports